function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAddMnp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.334,
    height: 26.077,
    viewBox: "0 0 18.334 26.077",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2473"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 416",
    d: "M183.224 904.211H169.71c-.151-.044-.3-.083-.451-.133a2.56 2.56 0 0 1-1.757-2.553v-18.978c0-.51-.006-1.02 0-1.53a2.489 2.489 0 0 1 .816-1.8 2.932 2.932 0 0 1 1.389-.688h13.513c.189.056.384.1.568.173a2.57 2.57 0 0 1 1.64 2.537v20.482a2.557 2.557 0 0 1-1.779 2.361c-.14.051-.283.088-.425.129zm-2.2-23.964q-.409 1.176-.817 2.342a.894.894 0 0 1-1.007.711h-5.455a.9.9 0 0 1-1.023-.725c-.239-.685-.488-1.368-.708-2.058a.342.342 0 0 0-.409-.279c-.449.019-.9.006-1.35.006-.742 0-1.048.306-1.048 1.049v20.16c0 .742.307 1.049 1.049 1.049h12.411c.756 0 1.059-.3 1.059-1.065V881.075a.831.831 0 0 0-.786-.825c-.635-.021-1.268-.004-1.917-.004zm-1.815.011h-5.483c.15.43.288.839.441 1.243a.221.221 0 0 0 .173.087q2.126.007 4.249 0a.236.236 0 0 0 .184-.108c.152-.396.286-.799.435-1.223z",
    transform: "translate(-167.299 -878.334)",
    style: {
      stroke: "#000",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 417",
    d: "M174.3 887.824v-3.505a.854.854 0 0 1 .845-.968c.529 0 .859.374.859.979v3.494h3.604a.844.844 0 0 1 .847.677.834.834 0 0 1-.483.948 1.183 1.183 0 0 1-.437.079c-1.076.006-2.152 0-3.228 0h-.3V893.148a.851.851 0 0 1-1.676.209 1.388 1.388 0 0 1-.025-.323v-3.509H170.686a.83.83 0 0 1-.839-.739.841.841 0 0 1 .642-.942 1.388 1.388 0 0 1 .323-.023c1.15.003 2.301.003 3.488.003z",
    transform: "translate(-165.989 -875.64)",
    style: {
      stroke: "#000",
      strokeWidth: ".4px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAddMnp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-addMnp.9fbb7895b7471c30bfe4a81af2755bc5.svg";